meedy.controller('meedy.popupCalendarTermViewController', ['$scope', '$state', '$mdDialog', '$mdToast', '$timeout', 'meedy.objectHelper', 'meedy.termModel', 'termId', 'meedy.patientModel', 'userModel', 'meedy.userModel', 'applicationModel', 'config', 'visitModel',
    function ($scope, $state, $mdDialog, $mdToast, $timeout, objectHelper, termModel, termId, patientModel, edmUserModel, userModel, applicationModel, config, visitModel) {

        function setData() {
            // isolated scope, needs these injected again
            $scope.Enum = Enum;
            $scope.Constant = Constant;

            $scope.term = null;
            $scope.termRefreshAfterVerify = false;

            $scope.offers = [];
            $scope.offerSum = 0;

            $scope.forms = {
                externalAppointment : null
            };
            $scope.isVerified = false;
            $scope.isItMine = false;

            $scope.zm = null;
        }

        function setPermissions() {
            $scope.inEdm = userModel.currentUser.inEdm;

            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isMedicalReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST;
            $scope.isReceptionist =  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;

            $scope.hasRightToVisitCardModule = function () {
                return edmUserModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS);
            };
        }

        function setListeners() {
            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$on(Event.MEEDY.TERM.GET_TERM_DETAILS.SUCCESS, function(event, data) {
                if ($scope.termRefreshAfterVerify) {
                    $scope.termRefreshAfterVerify = false;

                    var updatedTerm = data;
                    $scope.term.verified = updatedTerm.verified;
                    $scope.term.executionDate = updatedTerm.executionDate;

                } else {
                    $scope.term = data;

                    $scope.isItMine = data.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM || _.find(userModel.currentUser.resources, function(resource){
                        return data.resource && data.resource.id == resource.id;
                    }) != null;

                    if ($scope.term.suite) {
                        $scope.offerSum = $scope.term.suite.price;
                    }
                    else {
                        termModel.getAppointmentBillings($scope.term.id);
                    }

                    if(($scope.term.status === Enum.MEEDY.APPOINTMENT_STATUS.DONE || $scope.term.status === Enum.MEEDY.APPOINTMENT_STATUS.RESERVATION
                        || $scope.term.status === Enum.MEEDY.APPOINTMENT_STATUS.IN_PROGRESS) && $scope.inEdm) {
                        termModel.edmVisit($scope.term.id);
                    }

                    if($scope.term.type === Enum.MEEDY.TERM_TYPE.ONLINE_CONSULTATION && $scope.term.begin.getTime() > new Date().getTime()) {
                        $scope.blockVideoConsultation = true;
                    }
                }

                if(!$scope.term.verified) {
                    $scope.term.verificationCode = '';
                }
            });

            $scope.$on(Event.MEEDY.TERM.GET_APPOINTMENT_BILLINGS.SUCCESS, function(event, data) {
                var result = [];

                var sum = 0;

                _.each(data, function(appointmentBillingOffer) {
                    result.push({ offer: appointmentBillingOffer, active: true });
                    sum = sum + appointmentBillingOffer.medicalPostPrice;
                });

                $scope.offerSum = _.round(sum, 2);

                $scope.offers = result;
            });

            $scope.onOfferActiveChange = function () {
                $timeout(function () {
                    var sum = 0;

                    _.each($scope.offers, function (offer) {
                        if (offer.active) {
                            sum = sum + offer.offer.medicalPostPrice;
                        }
                    });

                    $scope.offerSum = _.round(sum, 2);
                });
            };

            $scope.$on(Event.MEEDY.TERM.VERIFY_APPOINTMENT.SUCCESS, function(event, data) {
                $scope.termRefreshAfterVerify = true;
                $scope.failedVerification = false;
                termModel.getTermDetails(termId);
            });

            $scope.$on(Event.MEEDY.TERM.VERIFY_APPOINTMENT.ERROR, function(event, data) {
                $scope.termRefreshAfterVerify = true;
                $scope.failedVerification = true;
            });

            $scope.$on(Event.VISIT.GET_ZM.SUCCESS, function(event, data) {
                $scope.zm = data;
            });

            $scope.$on(Event.VISIT.SEND_ZM.SUCCESS, function(event, data) {
                visitModel.getZM($scope.edmVisit.id);
            });

            $scope.$on(Event.MEEDY.TERM.EDM_VISIT.SUCCESS, function(event, edmVisit) {
                $scope.edmVisit = edmVisit;
                if(edmVisit.patient) {
                    if (config.DEMO) {
                        $scope.isVerified = true;
                    } else {
                        $scope.isVerified = !edmVisit.patient.toBeVerified;
                    }
                }
                if ($scope.edmVisit.id) {
                    visitModel.getZM($scope.edmVisit.id);
                }
            });

            $scope.onVerificationCodeChange = function() {
                if ($scope.term.verificationCode && ($scope.term.verificationCode.length >= 4)) {
                    termModel.verifyAppointment($scope.term.id, $scope.term.verificationCode);
                }
            };

            //$scope.$on(Event.MEEDY.TERM.BEGIN_APPOINTMENT.SUCCESS, function(event, data) {
            //    $mdDialog.hide();
            //    $state.go($scope.state, { patientId: $scope.term.patient.id, visitId: $scope.term.id });
            //});

            $scope.$on(Event.MEEDY.TERM.BEGIN.SUCCESS, function(event, data) {
                $mdDialog.hide();
                $scope.beginingInProgress = false;

                if($scope.term.type == Enum.MEEDY.TERM_TYPE.EXTERNAL || $scope.term.type == Enum.MEEDY.TERM_TYPE.ONLINE_CONSULTATION) {
                    var offers = [];
                    for(var i = 0; i < $scope.offers.length; i++) {
                        if($scope.offers[i].active) {
                            offers.push($scope.offers[i].offer.idOffer);
                        }
                    }
                    var updateAppointmentWrapper = new UpdateAppointmentWrapperVO();
                    updateAppointmentWrapper.eventName = $scope.term.eventName;
                    updateAppointmentWrapper.additionalRemarks = $scope.term.additionalRemarks;
                    updateAppointmentWrapper.appointmentBillingOffersIds = offers;

                    termModel.executeAppointment($scope.term.id, updateAppointmentWrapper);
                }
                // to jest newralgiczny warunek, który był już po wielokroć zmieniany w przeszłości.
                if((!data.patient.toBeVerified && $scope.hasRightToVisitCardModule() && !$scope.isReceptionist) || config.DEMO) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: data.patient.id, visitId: data.id, visitType: $scope.term.type });
                } else {
                    if($scope.isReceptionist) {
                        $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {
                            patientId: data.patient.id,
                            visitId: null,
                            visitType: $scope.term.type
                        });

                    } else {
                        $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {
                            patientId: data.patient.id,
                            visitId: data.id,
                            visitType: $scope.term.type
                        });
                    }

                }


            });

            $scope.$on(Event.MEEDY.TERM.BEGIN.ERROR, function() {
                $scope.beginingInProgress = false;
            });

        }

        function setActions() {
            $scope.delete = function () {
                if ($scope.term.type == Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) {

                    if ($scope.term.cyclic) {
                        $mdToast.show({
                            controller: 'meedy.toastCalendarCyclicTermModeController',
                            templateUrl: 'meedy/application/view/app/calendar/toast/calendar-cyclic-term-mode-toast.html',
                            parent : $('.calendarTermViewPopup'),
                            hideDelay: false,
                            position: 'bottom right'
                        }).then(
                            function(mode) {
                                termModel.deleteCyclicTerm(mode, $scope.term.id);

                                var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.DELETE_CYCLIC_TERM.SUCCESS, function (event, result) {
                                    successWatcherDisabler();
                                    errorWatcherDisabler();

                                    $mdDialog.hide(objectHelper.o(DialogResultVO, { data: $scope.term, eventName: Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_CYCLIC_DELETE }));
                                });

                                var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.DELETE_CYCLIC_TERM.ERROR, function (event, error) {
                                    successWatcherDisabler();
                                    errorWatcherDisabler();
                                });
                            },
                            function (error) {
                               // nothing
                            }
                        );
                    }
                    else {
                        termModel.deleteTerm($scope.term.id);

                        var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.DELETE_TERM.SUCCESS, function (event, result) {
                            successWatcherDisabler();
                            errorWatcherDisabler();

                            $mdDialog.hide(objectHelper.o(DialogResultVO, { data: $scope.term, eventName: Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_DELETE }));
                        });

                        var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.DELETE_TERM.ERROR, function (event, error) {
                            successWatcherDisabler();
                            errorWatcherDisabler();
                        });
                    }
                }
            };

            $scope.edit = function () {
                $mdDialog.hide(objectHelper.o(DialogResultVO, { data: $scope.term, eventName: Constant.MEEDY.DIALOG_EVENT.TERM.EDIT }));
            };

            $scope.cancelAppointment = function () {
                $mdDialog.hide(objectHelper.o(DialogResultVO, { data: $scope.term, eventName: Constant.MEEDY.DIALOG_EVENT.TERM.CANCEL }));
            };

            $scope.startAppointment = function () {
                $scope.beginingInProgress = true;
                termModel.begin(termId);
            };

            $scope.restartAppointment = function (visitType) {
                if($scope.isVerified) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: $scope.edmVisit.patient.id, visitId: $scope.edmVisit.id, visitType: visitType });
                } else {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, { patientId: $scope.edmVisit.patient.id, visitId: $scope.edmVisit.id });
                }
            };

            $scope.continueAppointment = function (visitType) {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: $scope.edmVisit.patient.id, visitId: $scope.edmVisit.id, visitType: visitType });
            };

            $scope.showMedicalDocumentation = function () {
                $mdDialog.hide();
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW, { patientId: $scope.edmVisit.patient.id, visitId: $scope.edmVisit.id });
            };

            $scope.ok = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.viewPatientPersonalData = function () {
                if($scope.edmVisit) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, { patientId: $scope.edmVisit.patient.id, visitId: $scope.edmVisit.id });
                }
            };

            $scope.viewPatientDataAsReceptionist = function (value) {
                if($scope.edmVisit && $scope.edmVisit.id && !value) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, { patientId: $scope.edmVisit.patient.id, visitId: null });
                } else {
                    $scope.beginingInProgress = true;
                    termModel.begin(termId);
                }
            };
            $scope.sendZM = function() {
              visitModel.sendZM($scope.edmVisit.id);
            };
        }

        function configureInterface() {

        }

        function initialize() {
            termModel.getTermDetails(termId);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
